import { Menu, Transition } from '@headlessui/react'
/* This example requires Tailwind CSS v2.0+ */
import React, { Fragment, useEffect, useState } from 'react'

import { FilledDownSvg } from 'icons'
import Input from '../Field/Input'
import { classNames } from 'helpers'

type DataType = {
  name: string
  onClick?: any
}

export interface DropdownProps {
  outlined?: boolean
  data: DataType[]
  search?: boolean
  selectedItem?: any
  className?: string
  setSelectedItem?: any
  icon?: any
  menuClassName?: string
  iconClassName?: string
}

function useInput(defaultValue: string) {
  const [value, setValue] = useState(defaultValue)
  function onChange(e: any) {
    setValue(e.target.value)
  }
  return {
    value,
    onChange,
  }
}

const Dropdown: React.FC<DropdownProps> = ({
  data,
  outlined,
  search,
  className,
  selectedItem,
  setSelectedItem,
  menuClassName,
  iconClassName,
  icon,
  ...args
}: any) => {
  const [items, setItems] = useState(data)
  const { value, onChange } = useInput('')
  const Icon = icon

  const handleSelect = (item: DataType) => {
    setSelectedItem(item)
  }

  useEffect(() => {
    let currentList = []
    let newList = []

    if (value !== '') {
      currentList = [...data]

      newList = currentList.filter((item) => {
        const lc = item.name.toLowerCase()
        const filter = value.toLowerCase()
        return lc.includes(filter)
      })
    } else {
      newList = data
    }
    setItems(newList)
  }, [value, data])

  return (
    <Menu
      as="div"
      className={`relative inline-block text-left font-manrope text-sm ${className}`}
      {...args}
    >
      {({ open }) => (
        <>
          <div>
            <Menu.Button
              className={classNames(
                'inline-flex items-center px-3 justify-between w-full rounded-t py-2 bg-white font-medium hover:bg-blue-0 focus:outline-none',
                outlined &&
                  'border border-blue-1 shadow-sm rounded-md',
                className
              )}
            >
              {selectedItem.name}
              {icon ? (
                <Icon
                  className={classNames(
                    iconClassName,
                    open && 'transform rotate-180'
                  )}
                />
              ) : (
                <FilledDownSvg
                  className="w-3 h-3 ml-3"
                  aria-hidden="true"
                />
              )}
            </Menu.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              className={classNames(
                'origin-top-right w-full absolute right-0 rounded-b bg-white ring-opacity-5 focus:outline-none z-50',
                outlined &&
                  'mt-2 ring-1 ring-black rounded-md shadow-lg'
              )}
            >
              <div
                className={classNames(
                  outlined && 'py-1',
                  menuClassName
                )}
              >
                {search && (
                  <Input
                    value={value}
                    onChange={onChange}
                    outlined={false}
                    shadow={false}
                    className="bg-blue-0"
                    placeholder="Search"
                  />
                )}
                {items.map((item: DataType) => (
                  <Menu.Item key={item.name}>
                    {({ active }) => (
                      <button
                        type="button"
                        onClick={() => handleSelect(item)}
                        className={classNames(
                          active
                            ? 'bg-blue-0 text-black'
                            : 'text-black',
                          'block px-3 py-2 cursor-pointer focus:outline-none w-full text-left'
                        )}
                      >
                        {item.name}
                      </button>
                    )}
                  </Menu.Item>
                ))}
              </div>
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  )
}

Dropdown.defaultProps = {
  selectedItem: {
    name: 'Options',
  },
  className: '',
  menuClassName: '',
}

export default Dropdown
